export const licenseHeaders = [
  {
    dataField: 'cd_license_kind',
    caption: 'License Kind',
    allowFiltering: false,
    allowSearch: { isSearchEnable: false, type: 'string' }
  },
  {
    dataField: 'cd_endorsement',
    caption: 'Endorsement',
    allowFiltering: false,
    allowSearch: { isSearchEnable: false, type: 'string' }
  }
];
 
export const jurisdictionHeaders = [
  {
    dataField: 'cd_state',
    caption: 'State',
    allowFiltering: false,
    allowSearch: { isSearchEnable: false, type: 'string' },
    ariaLabel: 'State'
  },
  {
    dataField: 'license_number',
    caption: 'License Number',
    allowFiltering: false,
    allowSearch: { isSearchEnable: false, type: 'string' },
    ariaLabel: 'License Number'
  },
  {
    dataField: 'cd_license_status',
    caption: 'License Status',
    allowFiltering: false,
    allowSearch: { isSearchEnable: false, type: 'string' },
    ariaLabel: 'License Status'
  }
];
 
export const educationHeaders = [
  { dataField: 'institution_name', caption: 'Institution Name', allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' } },
  { dataField: 'cd_institution_location', caption: 'Institution Location', allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' } },
  { dataField: 'cd_credential_type', caption: 'Credential Type', allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' } },
  { dataField: 'cd_degree_earned', caption: 'Degree Earned', allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' } },
  { dataField: 'completion_date', caption: 'Completion Date', allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'date' } },
  { dataField: 'credit_earned', caption: 'Credits Earned', allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' } },
  { dataField: 'cd_field_of_study', caption: 'Field of Study', allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' } },
  { dataField: 'program_name', caption: 'Program Name', allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' } }
];
 
export const nevadaTestingHeaders = [
  { dataField: 'cd_test_name', caption: 'Test Name', allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' } },
  { dataField: 'test_date', caption: 'Test Date', allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' } },
  { dataField: 'score', caption: 'Score', allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' } },
  { dataField: 'test_result_neveda', caption: 'Result', allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' } },
  { dataField: 'updated_by', caption: 'Updated By', allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' } },
];
 
export const outOfStateTestingHeaders = [
  { dataField: 'cd_state', caption: 'State', allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' } },
  { dataField: 'test_name', caption: 'Test Name', allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' } },
  { dataField: 'test_date', caption: 'Test Date', allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' } },
  { dataField: 'score', caption: 'Score', allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' } },
  { dataField: 'cd_result', caption: 'Result', allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' } }
];
export const priorNamesHeaders = [
  { dataField: 'prior_first_name', caption: 'Prior First Name', allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' } },
  { dataField: 'prior_middle_name', caption: 'Prior Middle Name', allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' } },
  { dataField: 'prior_last_name', caption: 'Prior Last Name', allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' } },
  { dataField: 'cd_suffix', caption: 'Suffix', allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' } },
];
export const workExperienceHeaders =[
  { dataField: 'employer_name', caption: 'Employer Name', allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' } },
]
export const teachingExperienceHeaders =[
  { dataField: 'cd_state', caption: 'State', allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' } },
  { dataField: 'cd_status', caption: 'Status', allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' } },
  { dataField: 'cd_date', caption: 'Date of Services', allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' } },
]
export const currentLicenseKindEndorsementHeaders = [
  { dataField: 'cd_license_type', caption: 'License Type', allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' } },
  { dataField: 'cd_license_kind', caption: 'License Kind', allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' } },
  { dataField: 'cd_endorsement', caption: 'Endorsement - Grade', allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' } },
  { dataField: 'endorsement_pathway', caption: 'Endorsement Pathway', allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' } },
  { dataField: 'original_effective_date', caption: 'Original Effective Date', allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' } },
  { dataField: 'effective_date', caption: 'Effective Date', allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' } },
  { dataField: 'expiration_date', caption: 'Expiration Date', allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' } },
  { dataField: 'cd_endo_status', caption: 'Endorsement Status', allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' } }
];
export const licenseProvisionsHeaders = [
  { dataField: 'provision', caption: 'Provision', allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' } },
  { dataField: 'license_kind', caption: 'License Kind', allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' } },
  { dataField: 'due_date', caption: 'Due Date', allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' } },
  { dataField: 'resolved_date', caption: 'Resolved Date', allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' } },
  { dataField: 'additional_text', caption: 'Additional Text', allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' } },
  { dataField: 'status', caption: 'Status', allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' } },
];
export const endorsementProvisionsHeaders = [
  { dataField: 'provision', caption: 'Provision', allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' } },
  { dataField: 'endorsement', caption: 'Endorsement', allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' } },
  { dataField: 'due_date', caption: 'Due Date', allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' } },
  { dataField: 'resolved_date', caption: 'Resolved Date', allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' } },
  { dataField: 'additional_text', caption: 'Additional Text', allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' } },
  { dataField: 'status', caption: 'Status', allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' } },
];
export const licenseRequirementsHeaders = [
  { dataField: 'requirement', caption: 'Requirement', allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' } },
  { dataField: 'type', caption: 'Type', allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' } },
  { dataField: 'due_date', caption: 'Due Date', allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' } },
  { dataField: 'resolved_date', caption: 'Resolved Date', allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' } },
  { dataField: 'additional_text', caption: 'Additional Text', allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' } },
  { dataField: 'status', caption: 'Status', allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' } },
];
export const profDevCollegeHeaders = [
  { dataField: 'institution_name', caption: 'Institution Name', allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' } },
  { dataField: 'course_name', caption: 'Course Name', allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' } },
  { dataField: 'credits_earned', caption: 'Credits Earned', allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' } },
  { dataField: 'prof_dev_hrs', caption: 'Professional Development Hours', allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' } }
];

export const profDevEmploymentHeaders = [
  { dataField: 'district_charter_name', caption: 'District/ Charter School Name', allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' } },
  // { dataField: 'cd_school', caption: 'School', allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' } },
  // { dataField: 'course_training_name', caption: 'Course/Training Name', allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' } },
  // { dataField: 'completion_date', caption: 'Completion Date', allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'date' } },
  { dataField: 'district_charter_prof_dev_hrs', caption: 'Professional Development Hours', allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' } }
];

export const profDevAdditionalHeaders = [
  { dataField: 'provider_name', caption: 'Provider Name', allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' } },
  // { dataField: 'course_name', caption: 'Course Name', allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' } },
  // { dataField: 'completion_date', caption: 'Completion Date', allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'date' } },
  { dataField: 'additional_prof_dev_hrs', caption: 'Professional Development Hours', allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' } }
];

export const ROMAN_SUFFIX_MAP: { [key: string]: string } = {
  'Jr.': 'Junior',
  'Sr.': 'Senior',
  I: 'One',
  II: 'Two',
  III: 'Three',
  IV: 'Four',
  V: 'Five',
  VI: 'Six',
  VII: 'Seven',
  VIII: 'Eight',
  IX: 'Nine',
  X: 'Ten'
};
 
// export const configData = {
//     data:null,
//       customHeaders:null,
//       showActionsColumn: false,
//       showFiltering: false,
//       showSearchRow: false,
//       showPaging: true,
//       customNoDataText: 'No data',
//       role: '',
//       activeTab: ''
// }
export const SURRENDER_NOTES =  [
  "Surrender Endorsement"
]

export const surrenderLicenseKind =[
        {dataField:"license_kind",caption:"License Kind",allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' },width:"150px" },
        {dataField:"provisions",caption:"Provisions",allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' } ,width:"350px"},
        {dataField:"endorsements",caption:"Endorsements",allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' } ,width:"350px"},
        {dataField:"request_notes",caption:"Request Notes",allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' },width:"150px" }
    ]

export const surrenderEndorsement =[
        {dataField:"license_kind",caption:"License Kind",allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' },width:"250px" },
        {dataField:"endorsements",caption:"Endorsement",allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' },width:"450px" },
        {dataField:"request_notes",caption:"Request Notes",allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' },width:"300px" },
        {dataField:"action_notes",caption:"Analyst Communication",allowFiltering:false,allowSearch:{isSearchEnable:false , type:"string"},width:"300px"}
    ]
    
export const surrendNotes = [
        {dataField:"section_code",caption:"Section",allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' } },
        {dataField:"note_text",caption:"Notes",allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' } },
        {dataField:"updated_date",caption:"Updated Date",allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' } },
        {dataField:"created_name",caption:"Updated By",allowFiltering: false, allowSearch: { isSearchEnable: false, type: 'string' } }
    ]

 